import { render } from "./ArtistFilter.vue?vue&type=template&id=2a781588&scoped=true"
import script from "./ArtistFilter.vue?vue&type=script&lang=js"
export * from "./ArtistFilter.vue?vue&type=script&lang=js"

import "./ArtistFilter.vue?vue&type=style&index=0&id=2a781588&scoped=true&lang=less"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a781588"]])

export default __exports__